import React, { useCallback, useEffect, useRef, useState } from "react";
import "./pausescreen.css";
import useNavigation from "../../hooks/useNavigation";
import useTextFadeSwitcher from "../../hooks/useTextFadeSwitcher";
import { animated } from "react-spring";
import useIsPc from "../../hooks/useIsPc";
import {useScribeContext} from "../../contexts/scribe/scribe-provider";

const IdleScreen: React.FC = () => {
  const idleTimerRef = useRef<number | null>(null);
  const [isPaused, setIsPaused] = useState(false);
  const [userInteracted, setUserInteracted] = useState(false);
    const { reset: resetScribe } = useScribeContext();

  const { navigateToScreensaver, isScreensaverActive } = useNavigation();
  const isPc = useIsPc();

    const {
        text: textTitle,
        fadeProps: fadePropsTitle,
        textStyle: titleStyle,
    } = useTextFadeSwitcher(
        "SEI ANCORA QUI?",
        "ARE YOU STILL HERE?",
        3000,
        "25px",
    );

    const {
        text: textSub,
        fadeProps: fadePropsSub,
        textStyle: subStyle,
    } = useTextFadeSwitcher(
        "TOCCA UN PUNTO QUALSIASI PER CONTINUARE",
        "TOUCH ANY POINT TO CONTINUE",
        3000,
        "20px",
    );

  const startScreensaverTimer = useCallback(() => {

    return window.setTimeout(() => {
      navigateToScreensaver();
    }, 15000); // 15 seconds countdown
  }, [navigateToScreensaver]);

  const startIdleTimer = useCallback(() => {

    if (idleTimerRef.current !== null) {
      clearTimeout(idleTimerRef.current);
    }
    return window.setTimeout(() => {
      if (!userInteracted) {
        startScreensaverTimer();
        setIsPaused(true);
      }
    }, 10000); // 10 seconds idle time
  }, [isPaused, startScreensaverTimer, userInteracted]);

    // Funzione per gestire l'inattività
    const handleInactivity = useCallback(() => {
        // Resetta il timer se è già in esecuzione
        if (idleTimerRef.current !== null) {
            clearTimeout(idleTimerRef.current);
            setIsPaused(false);
        }
        idleTimerRef.current = startIdleTimer();
    }, [startIdleTimer]);



    useEffect(() => {
        if (isScreensaverActive()) return;

        // Aggiunge listener per vari tipi di eventi
        const activityListener = () => {
            handleInactivity();
            setUserInteracted(true);
            console.log("hai inserito attività utente")
        };

        document.addEventListener("mousemove", activityListener);
        document.addEventListener("touchstart", activityListener);
        document.addEventListener("click", activityListener);

        return () => {
            // Rimuove i listener e cancella i timer
            if(idleTimerRef.current !== null)
            {
                clearTimeout(idleTimerRef.current);

            }
            document.removeEventListener("mousemove", activityListener);
            document.removeEventListener("touchstart", activityListener);
            document.removeEventListener("click", activityListener);
        };
    }, [handleInactivity, isScreensaverActive]);

  const handleClick = () => {
    handleInactivity();
    setIsPaused(false);
    setUserInteracted(true);
  };

  return (
    <>
      {!isScreensaverActive() && isPaused &&  (
        <div
          className={isPc ? "PauseScreen" : "PauseScreenMobile"}
          onClick={handleClick}
        >
          <div>
            <animated.h1
              style={{
                ...fadePropsTitle,
                ...titleStyle,
              }}
            >
              {textTitle}
            </animated.h1>
            <animated.h1
              style={{
                ...fadePropsSub,
                ...subStyle,
              }}
            >
              {textSub}
            </animated.h1>
          </div>
        </div>
      )}
    </>
  );
};

export default IdleScreen;
